module.exports = __webpack_public_path__ + "img/pic-1.9e0c2d60.png";